var checkout_forms = (function( $ ) {

	var $checkout;

	var _init = function() {
		$checkout = $( '#crate-checkout' );

		if ( $checkout.length > 0 ) {
			$( '#field_different_invoice_address' ).on( 'change', change_invoice_address_fields );

			$checkout.find( '#checkout-submission' ).on( 'click', _confirm_booking_event );
			$checkout.find( ':input' ).on( 'change', _change_input_event );

			if ( ! _is_discounted() ) {
				$.removeCookie( '_crate_discount_code', { path : '/' }  );
				$.removeCookie( '_crate_discount_code', { path : '/ajax.php' }  );
			}

			$( '#discount_code_form' ).on( 'saved', function( e, response ) {
				if ( response.new_price ) {
					var $price = $( '.checkout-summary' ).find( '.price' );
					$price.addClass( 'discount' );

					$price.html( response.new_price );
					$( '#ginput_base_price_1_8' ).val( response.new_price_unformatted );

					if ( response.is_free ) {
						$price.addClass( 'free' );
						$( '.checkout-payment-details' ).addClass( 'free' );
					} else {
						$price.removeClass( 'free' );
						$( '.checkout-payment-details' ).removeClass( 'free' );
					}
				}
			} );

			_initial_invoice_address_check();
		}
	};

	var _is_discounted = function() {
		return $( '.checkout-summary' ).find( '.price' ).hasClass( 'discounted' );
	};

	var _is_event_free = function() {
		return $( '.checkout-summary' ).find( '.price' ).hasClass( 'free' );
	};

	var _initial_invoice_address_check = function() {
		if ( $( '#field_different_invoice_address' ).is( ':checked' ) ) {
			$( '#field_company_name' ).removeAttr( 'disabled' ).removeAttr( 'readonly' );
			$( '#field_address_line_1' ).removeAttr( 'disabled' ).removeAttr( 'readonly' );
			$( '#field_address_line_2' ).removeAttr( 'disabled' ).removeAttr( 'readonly' );
			$( '#field_town_city' ).removeAttr( 'disabled' ).removeAttr( 'readonly' );
			$( '#field_postcode' ).removeAttr( 'disabled' ).removeAttr( 'readonly' );
		}
	};

	var change_invoice_address_fields = function( e ) {
		var fill = ! $( '#field_different_invoice_address' ).is( ':checked' );

		if ( fill ) {
			$.get( ScriptData.ajaxurl, {
				action : 'crate_get_invoice_address',
				nonce : ScriptData.get_invoice_address_nonce
			}, _fill_invoice_address_fields );
		} else {
			$( '#field_company_name' ).removeAttr( 'disabled' ).removeAttr( 'readonly' ).val( '' );
			$( '#field_address_line_1' ).removeAttr( 'disabled' ).removeAttr( 'readonly' ).val( '' );
			$( '#field_address_line_2' ).removeAttr( 'disabled' ).removeAttr( 'readonly' ).val( '' );
			$( '#field_town_city' ).removeAttr( 'disabled' ).removeAttr( 'readonly' ).val( '' );
			$( '#field_postcode' ).removeAttr( 'disabled' ).removeAttr( 'readonly' ).val( '' );
		}
	};

	var _fill_invoice_address_fields = function( response ) {
		$( '#field_company_name' ).attr( 'disabled', 'disabled' ).attr( 'readonly', 'readonly' ).val( response.address.company_name );
		$( '#field_address_line_1' ).attr( 'disabled', 'disabled' ).attr( 'readonly', 'readonly' ).val( response.address.address_line_1 );
		$( '#field_address_line_2' ).attr( 'disabled', 'disabled' ).attr( 'readonly', 'readonly' ).val( response.address.address_line_2 );
		$( '#field_town_city' ).attr( 'disabled', 'disabled' ).attr( 'readonly', 'readonly' ).val( response.address.town_city );
		$( '#field_postcode' ).attr( 'disabled', 'disabled' ).attr( 'readonly', 'readonly' ).val( response.address.postcode );
	};

	var _confirm_booking_event = function ( e ) {
		e.preventDefault();

		if ( $( this ).attr( 'disabled' ) || $( '.gform_ajax_spinner' ).length > 0 ) {
			return false;
		}

		$( this ).attr( 'disabled', true );

		_confirm_booking( false );
	};

	var _change_input_event = function( e ) {
		if ( $checkout.find( '#checkout-submission' ).hasClass( 'submission-attempted' ) ) {
			_confirm_booking( true );
		}
	};

	var _confirm_booking = function( autosave ) {
		var payment_method = $( '.payment-tabs' ).find( '.tab.active' ).data( 'tab' );

		payment_method = _is_event_free() ? 'free' : payment_method;

		var data = {
			event : $checkout.find( '#checkout-submission' ).data( 'event' ),
			dietary_requirement_q: $( '#field_dietary_requirement_q' ).val(),
			dietary_requirement: $( '#field_dietary_requirement' ).val(),
			learning_requirement_q: $( '#field_learning_requirement_q' ).val(),
			learning_requirement: $( '#field_learning_requirement' ).val(),
			access_requirement_q: $( '#field_access_requirement_q' ).val(),
			access_requirement: $( '#field_access_requirement' ).val(),
			source: $( '#field_source' ).val(),
			source_other: $( '#field_source_other' ).val(),
			payment_method: payment_method,
			cancellation_policy: $( '#field_cancellation_policy' ).is( ':checked' ) ? 1 : 0,
			terms_conditions: $( '#field_terms_conditions' ).is( ':checked' ) ? 1 : 0,
			newsletter_signup: $( '#field_newsletter_signup' ).is( ':checked' ) ? 1 : 0,
			autosave: autosave ? 1 : 0,
			create_booking : 1,
			different_invoice_address: $( '#field_different_invoice_address' ).is( ':checked' ) ? 1 : 0,
			_is_discounted : _is_discounted() ? 1 : 0
		};

		if ( 'practice' === payment_method ) {
			data.payment_details = {};

			data.payment_details.company_name = $( '#field_company_name' ).val();
			data.payment_details.address_line_1 = $( '#field_address_line_1' ).val();
			data.payment_details.address_line_2 = $( '#field_address_line_2' ).val();
			data.payment_details.town_city = $( '#field_town_city' ).val();
			data.payment_details.postcode = $( '#field_postcode' ).val();
			data.payment_details.practice_manager_fname = $( '#field_practice_manager_fname' ).val();
			data.payment_details.practice_manager_lname = $( '#field_practice_manager_lname' ).val();
			data.payment_details.practice_manager_email = $( '#field_practice_manager_email' ).val();
		}

		if ( 'individual' === payment_method ) {
			data.billing_details = {};

			data.billing_details.billing_address_line_1 = $( '#input_1_2' ).val();
			data.billing_details.billing_address_line_2 = $( '#input_1_3' ).val();
			data.billing_details.billing_town_city = $( '#input_1_4' ).val();
			data.billing_details.billing_postcode = $( '#input_1_5' ).val();
		}

		$.post( ScriptData.ajaxurl, {
			action: 'crate_create_booking',
			nonce: ScriptData.create_booking_nonce,
			booking_data : data
		}, _confirm_booking_response );
	};

	var _confirm_booking_response = function( response ) {
		$checkout.find( '#checkout-submission' ).addClass( 'submission-attempted' );

		$( '.field-wrap' ).removeClass( 'has-errors' );
		$( '.field-error' ).html( '' );
		$checkout.find( '#checkout-error' ).remove();

		var scroll = false;

		if ( ! response.autosave ) {
			$checkout.find( '#checkout-submission' ).attr( 'disabled', false );
		}

		if ( ! response.success ) {
			for ( var field in response.errors ) {
				if ( response.errors.hasOwnProperty( field ) ) {
					if ( 'checkout-general' === field ) {
						$checkout.prepend( '<div id="checkout-error">' + response.errors[ field ] + '</div>' );
						scroll = true;
					} else {
						$( '#field-wrap-' + field ).addClass( 'has-errors' );
						$( '#' + field + '-field-error' ).html( '<span class="required">' + response.errors[ field ] + '</span>' )
					}
				}
			}

			if ( ! response.autosave && scroll ) {
				$( 'html, body' ).animate( {
					scrollTop: $checkout.offset().top - 180
				}, 1000 );
			}

			return;
		}

		if ( ! response.autosave ) {
			$checkout.find( '#checkout-submission' ).addClass( 'booking-created' );
		}

		if ( response.trigger_gform ) {
			$( '#input_1_11' ).val( response.redirect );
			$( '#gform_submit_button_1' ).trigger( 'click' );
		} else if ( response.redirect ) {
			window.location.href = response.redirect;
		}
	};

	$( document ).ready( _init );

	return {
		change_invoice_address_fields: change_invoice_address_fields
	};

})( jQuery );

module.exports = checkout_forms;